function parseMs(iso) {
  if (!iso) return null;
  const ms = new Date(iso).getTime();
  return Number.isFinite(ms) ? ms : null;
}

/** Horario de la clase ya venció (usa end_time si existe). */
export function isLiveClassClosed(classItem) {
  const endMs = parseMs(classItem?.end_time || classItem?.start_time);
  if (endMs == null) return true;
  return endMs <= Date.now();
}

/** Clase en curso: ya empezó y aún no termina. */
export function isLiveClassInProgress(classItem) {
  const startMs = parseMs(classItem?.start_time);
  if (startMs == null) return false;
  return startMs <= Date.now() && !isLiveClassClosed(classItem);
}

/** Inscripción abierta mientras la clase no haya terminado (hasta end_time). */
export function isLiveClassEnrollable(classItem) {
  return !isLiveClassClosed(classItem);
}
